<a
    class="content-list__item content-list__item--simple content-list__link"
    [routerLink]="personItem.id"
>
    <h4 class="content-list__title">
        {{ personItem.forename + ' ' + personItem.surname }}
    </h4>
</a>
